import React, { Component } from 'react';
import { Link, Redirect, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import FormField from "../common/form/FormField";
import Form from "../common/form/Form";
import { getWord } from "../../tools/tools";
import { noSpace, numberMask } from "../../tools/mask";
import ready from "../../../img/notification_ready.svg";
import RegEcp from './RegEcp';

class Recovery extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            time: 0,
            token: location.search ? location.search.substr(7) : null,
            fieldsRecovery: {
                email: {
                    type: 'text',
                    label: "E-mail:",
                    name: "email",
                    value: "",
                    required: true,
                    error: '',
                    mask: noSpace,
                }
            },
            fieldsCodevalidate: {
                code: {
                    type: 'text',
                    label: "Введите код подтверждения, отправленный Вам в SMS:",
                    name: "authCode",
                    value: "",
                    // required: true,
                    error: '',
                    mask: numberMask(4),
                    min: 4,
                    ref: (input) => { this.codeInput = input; }
                }
            },
            fieldsEc: {
                digitalSignature: {
                    type: 'select-diadoc',
                    label: "Выберите электронную подпись",
                    placeholder: "Выберите подпись",
                    name: "ecp",
                    value: "",
                    options: [],
                    // required: true,
                    error: '',
                },
            },
            disabled: false,
            recByDs: this.props.location && this.props.location.state && this.props.location.state.recByDs || false
        };

    }

    componentWillReceiveProps(nextProps) {
        if (this.props.recoveryErrors != nextProps.recoveryErrors) {
            var state = { ...this.state };
            for (var attr in state.fieldsRecovery) {
                state.fieldsRecovery[attr].error = nextProps.recoveryErrors && nextProps.recoveryErrors[attr] || ''
            }
            this.setState(state);
        }
        if ((this.props.step != nextProps.step) && nextProps.step === 2) {
            clearInterval(this.timer);
            this.setState({ time: 30 }, () => {
                this.timer = setInterval(this.setTime, 1000);
            });
        }
        if (this.props.codevalidateErrors != nextProps.codevalidateErrors) {
            var state = { ...this.state };
            for (var attr in state.fieldsCodevalidate) {
                state.fieldsCodevalidate[attr].error = nextProps.codevalidateErrors[attr] || ''
            }
            this.setState(state);
        }
        if (this.props.triesMore != nextProps.triesMore) {
            clearInterval(this.timer);
            this.setState({ time: 30 }, () => {
                this.timer = setInterval(this.setTime, 1000);
            });
        }
        if (this.props.fields.code != nextProps.fields.code) {
            this.setState({ fieldsCodevalidate: { code: { ...this.state.fieldsCodevalidate.code, value: nextProps.fields.code } } });
        }
    }

    static contextTypes = {
        screenSize: PropTypes.string,
        currentLanguage: PropTypes.object,
        translate: PropTypes.func
    };
    componentDidUpdate(prevProps) {
        const { diadocState } = this.props;
        const { selectedCerf } = this.props.diadocState

        if (prevProps.diadocState !== diadocState) {
            this.setState(prevState => ({
                fieldsEc: {
                    ...prevState.fieldsEc,
                    digitalSignature: {
                        ...prevState.fieldsEc.digitalSignature,
                        options: this.props.diadocState.userCertificate
                        // options: Array(3).fill(this.props.diadocState.userCertificate).flat()
                    }
                }
            }));
        }
    }

    funcState = (prevState) => {
        if (this.state.time < 1) {
            clearInterval(this.timer);
            return { time: 0 };
        }
        var timer = --prevState.time;
        if (timer < 10) timer = '0' + (timer.toString());
        return { time: timer };
    };

    setTime = () => {
        this.setState(this.funcState);
    };


    onChangeField = (name) => {
        return (attribute, value, error) => {
            var prevState = { ...this.state[name] };
            if (prevState.hasOwnProperty(attribute)) {
                prevState[attribute].value = value;
                prevState[attribute].error = error;
                this.setState({
                    ...this.state,
                    [name]: prevState
                })
            }
        }
    };

    onCodeRequest = () => {

        var {
            email
        } = this.state.fieldsRecovery;

        var body = new FormData();
        body.append('email', email.value);

        this.codeRequestBtn.focus();

        this.props.recovery('code-send', body);
    }

    onRepeatCodeRequest = (e) => {
        e.preventDefault();
        this.setState({ time: 30 }, () => {
            this.timer = setInterval(this.setTime, 1000);
            this.onCodeRequest();
        });
    }

    onCodeValidate = () => {
        var body = new FormData();
        body.append('email', this.props.fields.email);
        body.append('code', this.state.fieldsCodevalidate.code.value);

        this.props.recovery('code-validate', body);
    }

    onChangePassword = (password) => {
        var body = new FormData();
        body.append('password', password);
        body.append('recovery_token', this.state.token);

        this.props.recovery('change-password', body);
    }

    isValid = (name) => {
        var fields = { ...this.state[name] };
        for (var attr in fields) {
            if (fields[attr].error || fields[attr].required && !fields[attr].value) return false;
        }
        return true;
    }

    renderFields = (fields, name) => {
        var result = [];

        for (var attribute in fields) {
            if (fields.hasOwnProperty(attribute)) {

                result.push(<div className="form__row" key={name + attribute}>
                    <FormField fieldConfig={{ ...fields[attribute], label: this.context.translate(fields[attribute].label) }}
                        attribute={attribute}
                        onChange={this.onChangeField(name)}
                        isRegPage
                    />
                </div>)
            }
        }

        return result;
    };
    onSelecSignature = (attribute, value) => {
        this.setState(prevState => ({
            fieldsEc: {
                ...prevState.fieldsEc,
                digitalSignature: {
                    ...prevState.fieldsEc.digitalSignature,
                    value: value
                }
            }
        }));
        this.props.getCerfInfoAction(value)


    };

    onRecByEcpSubmit = () => {
        this.setState(prevState => ({
            disabled: true,
        }))
        const cerfInfo = JSON.stringify({ requestTime: new Date(Date.now()) })
        const encoder = new TextEncoder();
        const uint8Array = encoder.encode(cerfInfo);
        const base64String = btoa(String.fromCharCode.apply(null, uint8Array));
        this.props.signCertificateAction(this.state.fieldsEc.digitalSignature.value, base64String)
        this.props.checkSignature(cerfInfo)
    }

    handleCloseRecDs = () => {
        this.setState({ recByDs: false })
    }

    render() {


        if (location.search) return <Redirect to="recovery" push={false} />

        let {
            fieldsRecovery,
            fieldsCodevalidate,
            time,
            token,
            disabled
        } = this.state;

        let {
            step,
            triesMore,
            toCodeRequest,
            sendRequest,
            regByDsAct,
            authByDsAct
        } = this.props;
        return (
            <div>
                {this.state.recByDs ? <RegEcp
                    diadocState={this.props.diadocState}
                    fieldsEc={this.state.fieldsEc}
                    onSubmit={this.onRecByEcpSubmit}
                    getUserCertificatesAction={this.props.getUserCertificatesAction}
                    getCerfInfoAction={this.props.getCerfInfoAction}
                    onSelecSignature={this.onSelecSignature}
                    recByDs={this.state.recByDs}
                    handleCloseRecDs={this.handleCloseRecDs}
                    regByDsAct={regByDsAct}
                    authByDsAct={authByDsAct}
                    disabled={disabled}
                /> :
                    <div className="auth__form__reg">
                        {step !== 3 && <h3 className="reg__title">Восстановление пароля</h3>}
                        <Form className={"auth__form-slide" + (step == 1 ? " active" : "")}
                            validate={true}
                            onSubmit={this.onCodeRequest}
                        >
                            <div className='reg_inputs recovery'>
                                {this.renderFields(fieldsRecovery, 'fieldsRecovery')}
                            </div>
                            <p className='auth__link'>
                                <Link to={{ pathname: "/login", state: { switcher: false } }}>{this.context.translate("Вспомнили пароль?")}</Link>
                            </p>
                            <div className="form__buttons_auth recovery">
                                <button type='button' className='btn btn_clear_blue_auth recovery' onClick={() => this.setState({ recByDs: true })}>
                                    Войти по ЭП
                                </button>
                                <button type="submit"
                                    className={"btn btn_orange recovery" + (this.isValid('fieldsRecovery') && !sendRequest ? "" : " disabled_auth")}
                                    ref={(button) => { this.codeRequestBtn = button; }}
                                    disabled={!this.isValid('fieldsRecovery') || sendRequest}
                                >{this.context.translate("Восстановить")}</button>
                            </div>
                        </Form>
                        <Form className={"auth__form-slide" + (step == 2 ? " active" : "")}
                            validate={true}
                            onSubmit={this.onCodeValidate}
                        >
                            <div className='reg_inputs recovery'>
                                {this.renderFields(fieldsCodevalidate, 'fieldsCodevalidate')}
                            </div>
                            <div style={{ lineHeight: "20px" }}>
                                {time ? <p className='rec-counter'>{this.context.translate("Вы сможете запросить код повторно через {n} сек.", {
                                    n: "00:" + time
                                })}</p> : null}
                                <a href="#" className={time == 0 ? "rec-repeat" : "disabled"}
                                    onClick={this.onRepeatCodeRequest}>{this.context.translate("Запросить повторно")}</a>
                            </div>
                            {triesMore ? triesMore === 0 ? <div className="form__message">
                                <div className="form__message-fix">
                                    <p>{this.context.translate("Ваш аккаукнт заблокирован.")}</p>
                                </div>
                            </div> :
                                <div className="form__message">
                                    <div className="form__message-fix tries">
                                        <p>{this.context.translate("У вас осталось {n} {unit} ввести код, после чего аккаунт будет заблокирован.", {
                                            n: triesMore,
                                            unit: getWord(triesMore, 'попытка', 'попытки', 'попыток')
                                        })}</p>
                                    </div>
                                </div> : null}
                            <div className="form__buttons_auth">
                                <button className="btn btn_clear_blue_auth" type="button" onClick={toCodeRequest}>{this.context.translate("Назад")}</button>
                                <button className={"btn btn_orange" + (this.isValid('fieldsCodevalidate') && !sendRequest && fieldsCodevalidate.code.value ? "" : " disabled_auth")} type="submit">{this.context.translate("Продолжить")}</button>
                            </div>
                        </Form>
                        {step === 3 ? <div className="email-send">
                            <p><img src={ready} /></p>
                            <div>
                                <h3 className="reg__title">Восстановление пароля</h3>
                                <p>
                                    {this.context.translate("На ваш e-mail, указанный при регистрации, отправлен временный пароль.")}
                                </p>
                            </div>
                            <Link to="/login">
                                <p className='recovery_btn'>
                                    {this.context.translate("Войти")}
                                </p>
                            </Link>
                        </div> : null}
                    </div>}
            </div>)
    }
}
export default withRouter(Recovery)